// extracted by mini-css-extract-plugin
export var csatScore = "_gi-5";
export var header = "_gi-1";
export var panelWrapper = "_gi-2";
export var postPreview = "_gi-3";
export var rightContent = "_gi-0";
export var wrappingText = "_gi-4";